import { render, staticRenderFns } from "./SettingsFooterActions.vue?vue&type=template&id=a3a2883a&scoped=true"
import script from "./SettingsFooterActions.vue?vue&type=script&lang=js"
export * from "./SettingsFooterActions.vue?vue&type=script&lang=js"
import style0 from "./SettingsFooterActions.vue?vue&type=style&index=0&id=a3a2883a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a2883a",
  null
  
)

export default component.exports